import { Select, SelectProps } from "antd";

import { TipoContatoEnum } from "core/features/auth/typings/user";
import SelectBaseAntd from "../SelectBaseAntd";

export interface SelectContatoProps<T = any> extends SelectProps<T> {
  value: any;
  isInvalid?: boolean;
  onChange: (v: any, e: any) => void;
}

const { Option } = Select;

function SelectContatoUnidade({
  onChange,
  isInvalid,
  value,
  ...rest
}: SelectContatoProps) {
  return (
    <SelectBaseAntd
      isInvalid={isInvalid}
      size="large"
      getPopupContainer={(node) => node.parentNode}
      placeholder="Tipo"
      value={value}
      showSearch={false}
      allowClear={false}
      {...rest}
      onChange={(v, ev) => {
        onChange(v, ev);
      }}
    >
      <Option value={TipoContatoEnum.Email}>Email</Option>
      <Option value={TipoContatoEnum.Telefone}>Telefone</Option>
      <Option value={TipoContatoEnum.Celular}>Celular</Option>
    </SelectBaseAntd>
  );
}

export default SelectContatoUnidade;
